<template>
  <div class="">
    <div class="mb-6">
      <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
        <div class="bg-theme-green px-4 py-2 text-white">
          <div class="flex justify-between items-center">
            <h2 class="font-bold break-all leading-tight text-2xl mt-0 mr-2">FAQ</h2>
            <div class="flex flex-end mb-1">
              <button v-if="can_edit_membership_details" @click.prevent="update()" class="  tracking-widest cursor-pointer bg-white py-2 px-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white mr-3">
                  SAVE
                </button>
                <button v-if="can_edit_membership_details" @click.prevent="openDeleteConfirmModal()" class="cursor-pointer rounded-md bg-white text-theme-red py-2 px-4  hover:bg-theme-darkgreen hover:text-white mr-3">DELETE</button>
                <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 hover:opacity-70">CLOSE</span>
                <!-- <button @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 px-4  hover:opacity-70 mr-3">CLOSE</button> -->
            </div>
          </div>
        </div>


        <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-b-lg">
          <div class="flex items-center flex-col gap-2 my-2">   
            <div class="w-full">
              <div :class="'input-wrapper ' + (form.question.error_type)">
                <label class="text-xs tracking-[0.4px]">Question</label>
                <input placeholder="Input Your Question Here"  @keyup="validateFields(['question'])" v-model="form.question.value" class="block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm" type="text">
                <p class="field-error label-text mt-1" v-if="form.question.error_message" v-text="form.question.error_message"></p>
              </div>
            </div>
            <div class="w-full">
              <div :class="'input-wrapper ' + (form.answer.error_type)">
                <label class="text-xs tracking-[0.4px]">Answer</label>
                <textarea placeholder="Input Your Answer Here" v-model="form.answer.value" @keyup="validateFields(['answer'])" class="block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm"></textarea>
                <p class="field-error label-text mt-1" v-if="form.answer.error_message" v-text="form.answer.error_message"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ReturnConfirmModal v-if="deleteObj.modal" :closeClick="closeDeleteModal" :actionClick="deleteFaq" :obj="deleteObj.obj" :heading="'You Are About To Delete an FAQ'"/>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';
import LoyaltyFaqApis from "@/controllers/LoyaltyFaqApis";
import ReturnConfirmModal from "@/components/general/dialog/ReturnConfirmModal.vue";

export default defineComponent({
  name: "MembershipFaqsUpdate",
  components: {
    ReturnConfirmModal
  },
  props:{
    loyaltyProgram: {
      type: Object,
      required: true,
    },
    faqCategory: {
      type: Object,
      required: true,
    },
    clearComponent: {
      type: Function,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const snackbar = useSnackbar();
    const form = <any>ref({
      question: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      },
      answer: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      },
      sort_order: 1,
    });
    const deleteObj = ref({
      modal: false,
      obj: {},
    });
    return {
      form,
      snackbar,
      deleteObj
    };
  },

  watch:{
    'item'() {
      this.assignValues();
    },
  },

  computed: {
    ...mapGetters({
     
    }),
    /**
     * Edit restriction
     */
    can_edit_membership_details() {
      return Helpers.getMyPermission('can_edit_membership_details')
    },
  },

  mounted() {
    this.assignValues();
  },
 
  methods: {
    /**
     * Assign fields 
     */
    async assignValues() {
      this.form = await Helpers.assignFormValues(this.form, this.item);
    },
   /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },
    
    /**
     * Update
     */
    async update() {
      let validate = await this.validateFields(['question', 'answer', 'sort_order']);
      if(!validate) {
        return ;
      }
      this.va_spinner(true);
      let res = await LoyaltyFaqApis.update(this.loyaltyProgram.id, this.faqCategory.id, this.item.id, Helpers.getFormKeyValue(this.form));
      this.va_spinner(false);
      if(res.status == 200 ) {
        this.clearComponent();
        this.emitter.emit("refresh-faqs-list", true);
      }
      this.snackbar.add({
        type: 'info',
        text: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
    },

     /**
       * Open delete confirm modal
       */
      openDeleteConfirmModal() {
        this.deleteObj = {
          modal: true,
          obj: this.item,
        };
      },

      /**
       * Close delete confirm modal
       */
      closeDeleteModal() {
        this.deleteObj = {
          modal: false,
          obj: {},
        };
      },

     /**
     * Delete  
     */
      async deleteFaq(obj) {
        this.va_spinner(true);
        let res = await LoyaltyFaqApis.remove(this.loyaltyProgram.id, this.faqCategory.id, this.item.id);
        this.va_spinner(false);
          this.snackbar.add({
          type: 'info',
          text: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
        if(res.status == 200 ) {
          this.clearComponent();
          this.emitter.emit("refresh-faqs-list", true);
        }
      },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>